<template>
  <RequireAdContract>
    <Content
      v-if="isLoading || hasError"
      :title="$t('ADVERTISEMENT.MAIL_SERVICE')"
    >
      <Card v-if="isLoading" is-loading />
      <CardApiError v-else-if="hasError" @retry="handleGetEmails" />
    </Content>

    <Transition v-else mode="out-in" name="fade-transform">
      <MailServiceEmpty v-if="!hasEmails" @newMail="showNewMailModal" />
      <MailServicePage v-else />
    </Transition>

    <MailServicePageAddModal v-model="shouldShowNewMailModal" />
  </RequireAdContract>
</template>

<script>
import RequireAdContract from '../common/RequireAdContract';
import MailServiceEmpty from './MailServiceEmpty';
import MailServicePage from './MailServicePage';
import MailServicePageAddModal from './common/components/MailServicePageAddModal';
import { mapActions, mapGetters } from 'vuex';
import { MAIL_SERVICE } from '@/store/types';
import Card from '@@/common/Card';
import Content from '@@/common/layout/Content';
import CardApiError from '@@/common/CardApiError';
import { AD_MAIL_SERVICE_ADD_BUTTON } from '@/constants/gtm-events';

export default {
  name: 'MailService',
  components: {
    MailServiceEmpty,
    MailServicePage,
    MailServicePageAddModal,
    Card,
    CardApiError,
    Content,
    RequireAdContract,
  },
  data() {
    return {
      shouldShowNewMailModal: false,
      isLoading: true,
      hasError: false,
    };
  },
  computed: {
    ...mapGetters({
      emails: MAIL_SERVICE,
    }),
    hasEmails() {
      return Boolean(this.emails.length);
    },
  },
  mounted() {
    this.handleGetEmails();
  },
  methods: {
    ...mapActions({
      getEmails: MAIL_SERVICE,
    }),
    handleGetEmails() {
      this.isLoading = true;
      this.hasError = false;

      return this.getEmails()
        .catch(({ message }) => {
          this.hasError = true;
          this.$message.error(message);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    showNewMailModal() {
      this.$gtm.trackEvent(AD_MAIL_SERVICE_ADD_BUTTON);

      this.shouldShowNewMailModal = true;
    },
  },
};
</script>
